// Реестр ключей LocalStorage и URL. Ключи, специфичные для одного слайса, объявляются
// рядом со слайсом (modules/*/storage.ts). Здесь — только сквозные, общие для приложения.

/** Ключи LocalStorage */
export const LOCAL_STORAGE_KEYS = {
  /** access-токен сессии, см. shared/api/http/tokenStorage */
  accessToken: 'lunya.auth.access_token',
  /** refresh-токен сессии */
  refreshToken: 'lunya.auth.refresh_token',
  /** флаг «онбординг пройден» */
  onboardingSeen: 'lunya.onboarding_seen',
  /**
   * Приглашение, по ссылке которого человек пришёл, но которое ещё не доведено до связи.
   *
   * Сквозной ключ, а не слайсовый, потому что его пишет самый ранний код приложения (разбор
   * `start_param`), а читают и онбординг, и главный экран — см. modules/link/utils/pendingInvite.
   */
  pendingInvite: 'lunya.pending_invite',
  /** пользовательские настройки темы (в проекте всегда тёмная, ключ — задел на будущее) */
  theme: 'lunya.theme',
} as const

/** Ключи query-параметров URL (url-storage, см. docs/persist.md) */
export const URL_STORAGE_KEYS = {
  /** открытая шторка экрана (диплинк на архив прогнозов и т.п.) */
  sheet: 'sheet',
  /** черновик прохождения совместимости */
  compatDraft: 'compat',
  /**
   * Черновик данных натальной карты — и своей, и чужой. Для чужой это единственное место, где
   * данные вообще живут: на сервере они не сохраняются (POST /natal/preview считает и забывает).
   */
  natalDraft: 'natal',
} as const
